import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { FormDialogFormulaireWithSFComponent } from "../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component"
import { InstructionService, DossierService,DialogService, FormulaireService, StateService, VisiteService } from "../../../../../services"
import { EventEmitter,Output} from '@angular/core'
import {  first  } from 'rxjs/operators'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { InstructionActionsDialog } from '../../../content/actions/instruction-actions-dialog/instruction-actions-dialog.component'
import { event } from 'jquery'

const KEY = 'instruction-listing'

@Component({
  selector: 'atyl-instruction-listing',
  templateUrl: './instruction-listing.component.html',
  styleUrls: ['./instruction-listing.component.scss']
})

@Stringable({
    path: 'views/partials/content/listing/instruction-listing',
    key: KEY,
})

export class InstructionListing extends BaseDialogComponent implements OnInit {
  
  @StringableValues(KEY) strings: any
  dossier: any
  type:string='';
  formulaire: any;
  document: any;
  courrier: any;
  visite: any;
  loading: boolean = false;
  
  menuProcedure: any[] = [];
  instructions : any=[];
  selectedInstruction: any;
  cacheInstruction: any;
  
  showList: boolean = false;
  
  @Output() onFormClosed = new EventEmitter<any>();
  
  instruction_restriction:any[]=[];
  
  constructor(
    private stateService: StateService,
    private  dossierService: DossierService,
    private instructionService:InstructionService,
    changeDetectorRef: ChangeDetectorRef,
    dialogRef: MatDialogRef<InstructionListing>,
    dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
	
	console.log("InstructionListing init",this.data);
	
    if (this.data != undefined && this.data.dossier != undefined  && this.data.dossier) {
            this.dossier = this.data.dossier
     }
    
     if (this.data != undefined && this.data.formulaire != undefined  && this.data.formulaire) {
            this.formulaire = this.data.formulaire;
            this.type='formulaire';
     }
    
     if (this.data != undefined && this.data.courrier != undefined  && this.data.courrier) {
            this.courrier = this.data.courrier;
              this.type='courrier';
     }
     
     if (this.data != undefined && this.data.document != undefined  && this.data.document) {
            this.document = this.data.document;
              this.type='document';
     }
     if (this.data != undefined && this.data.visite != undefined  && this.data.visite) {
            this.visite = this.data.visite;
              this.type='visite';
     }
     
     if (this.data != undefined && this.data.visite_add != undefined  && this.data.visite_add) {
            this.visite = this.data.visite_add;
			
			if (this.visite.consultation!=undefined 
				&& this.visite.consultation.type!=undefined 
				&& this.visite.consultation.type.instructions!=undefined 
			)
				this.instruction_restriction=this.visite.consultation.type.instructions;
			
			console.log("InstructionListing init visite",this.visite,this.instruction_restriction);
              this.type='visite_add';
     }
     if(this.visite != undefined && this.visite){
         this.dossierService.get(this.dossier.dossierID).subscribe(dossier =>{
            if(dossier){
                this.visite.dossier = dossier.result;
                this.changeDetectorRef.detectChanges();
            }
        })
     }

     this._initInstruction();
  }


  private _initInstruction() {
    
    let id:any=(this.dossier.dossierID!=undefined) ?   this.dossier.dossierID : this.dossier.ID;
    this.dossierService.getinstructionlist(id).pipe(first())
                .subscribe((r: JSONRpcResponse) => 
                {
                 console.log("result getinstructionlist",r.result,r.result.instructions)   
                  this.instructions=r.result.instructions;  
                  
                  this.showList = (this.instructions.length > 0);

                  this.changeDetectorRef.detectChanges();    
               }
        )
    
    
        let _options={
            formulaire:this.formulaire,
            courrier:this.courrier,
            document:this.document,
            visite:this.visite,
        }
        
        this.instructionService.getBy(this.type,_options).subscribe((r: JSONRpcResponse) => 
            {
                console.log("result getBy",r.result);   
                if (r.result.length>0) {
                this.selectedInstruction=r.result[0].ID;
                this.cacheInstruction=r.result[0].ID;
                }
                this.changeDetectorRef.detectChanges();    
            }
        )

        this.stateService.pages.subscribe((pages) => {
            this.menuProcedure = []
            let _params={
                
            }

            if(this.dossier){
                if(this.dossier.dossierID){
                    _params["type"]= this.dossier.type;
                    _params["id"]= this.dossier.dossierID;
                }
                else{
                    _params["type"]= this.dossier.tiers.type;
                    _params["id"]= this.dossier.ID;
                }
                let routeConfig="dossier/:type/:id";
                this.handelAction(pages, routeConfig,_params)
            }
        })
  }

  handelAction(pages: any, routeConfig: any, _params:any) {
	
	console.log("InstructionListinghandelAction",pages,routeConfig,_params);
	
	if (pages!=undefined && pages) {
	    const pagesFilter =  pages.filter(page=> page.url == routeConfig);
	    pagesFilter.forEach((page) => {
	        page.actions.forEach((action: any) => {
	            if (action.sous_groupe != undefined && action.sous_groupe.key == "PROCEDURE" 
	            && action.tiers_type != undefined) {
	                const rightType = action.tiers_type.find(tt=>tt.type.code == _params["type"])
	                if(rightType)
	                    this.menuProcedure.push(action);
	            } 
	        });     
	    })
	}	
}
  
  selectInstruction(event:any) {
    console.log("selectInstruction selectedInstruction:",this.selectedInstruction); 
  }
  
  submitForm(event: any) {
        let _options = {
            formulaire:this.formulaire,
            courrier:this.courrier,
            document:this.document,
            visite:this.visite,
        }; 
        console.log("submitForm selectedInstruction:",this.selectedInstruction); 
        if (this.cacheInstruction!=this.selectedInstruction) {
            this.instructionService.change(this.selectedInstruction, this.type, _options)
            .subscribe((res: JSONRpcResponse) => {
                if (res.result) {
                    console.log('set result', res.result);
                    this.dialogRef.close(true);
                    this.changeDetectorRef.detectChanges(); 
                }
            })
        }   

    }


    addProcedureOfVist(id: number, nom: string, instruction: string){
        
         let idd:any=(this.dossier.dossierID!=undefined) ?   this.dossier.dossierID : this.dossier.ID;
        let dataIns={
            action: "create",
            dataType: "consultation",
            // dossier:  this.visite.dossier,
            dossier: {ID:idd},
            visite: this.visite,
            title: "Création d'une procédure",
            create: true,
            instruction_type: instruction,
            link: {
				type: this.type,
				formulaire:this.formulaire,
	            courrier:this.courrier,
	            document:this.document,
	            visite:this.visite
            }
        }
         
		
        const instDial=this.dialogService.open(InstructionActionsDialog, {
                data: dataIns,
                width: '50vw',
                draggable: true,
                maximizable: true,
                minimizable: true,
                resizable: true,
            }, (res: any) => {
                console.log(res)
                if (res) {
                    let _refresh={
                        type: "instruction",
                        data:dataIns
                    };

                    this.stateService.updateRefresh(_refresh)
					
					instDial.close();
					this.dialogRef.close(true);
                    this.dossierService.getinstructionlist(this.dossier.dossierID).pipe(first())
                    .subscribe((r: JSONRpcResponse) => {
                        this.instructions=r.result.instructions;
                       
                        this.changeDetectorRef.detectChanges(); 
                    })
                }
                this.changeDetectorRef.detectChanges(); 
            })
    }
	
	_isBarredInstruction(type:any,isCode:boolean=false) {
		let barred:boolean=(this.instruction_restriction.length>0);
		
		for(let i=0;i<this.instruction_restriction.length;i++)
			if ((!isCode 
				&& this.instruction_restriction[i].ID==type.ID)
		      || (
				isCode 
				&& type.parametre!=undefined 
				 && type.parametre.instruction!=undefined  &&
				  this.instruction_restriction[i].key==type.parametre.instruction
				
			))
				barred=false;
		//console.log("_isBarredInstruction",type,barred)	
		return barred;
	}
    
}
